import { Card } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';

export const AuthCard = ({ children }: PropsWithChildren) => {
	return (
		<Card.Root p={0}>
			<Card.Body>
				{children}
			</Card.Body>
		</Card.Root>
	);
};
